import {
    BreachEvent,
    EntitledToView,
    ImageSourceWithCaptions,
    PublicationType,
    RequiredAccess,
} from '@news-mono/web-common'
import H from 'history'
import React, { Fragment } from 'react'
import {
    BreachNotificationWrapper,
    useBreachWallConfig,
} from './components/BreachNotificationWrapper/BreachNotificationWrapper'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import {
    StyledGalleryBreach,
    StyledGalleryBreachNotification,
} from './GalleryBreach.styled'

interface GalleryProps {
    requiredAccess: RequiredAccess
    location: H.Location
    images: ImageSourceWithCaptions[]
    onEvent: (event: BreachEvent) => void
    children: (
        content: {
            images: ImageSourceWithCaptions[]
        },
        entitled: boolean,
    ) => React.ReactElement<any>
    gallery: PublicationType
    slug: string
}

export const GalleryBreach: React.FC<GalleryProps> = (props) => {
    const {
        requiredAccess,
        location,
        images,
        onEvent,
        children,
        gallery,
        slug,
    } = props

    const { creativeName, deal, type } = useBreachWallConfig(location)

    return (
        <EntitledToView
            requiredAccess={requiredAccess}
            articleSlug={slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                creativeName,
                deal,
                location,
                onEvent,
            )}
            entitled={() => {
                return children({ images }, true)
            }}
            notEntitled={() => {
                const { children } = props
                return (
                    <Fragment>
                        <StyledGalleryBreach>
                            {children({ images: [] }, false)}
                        </StyledGalleryBreach>
                        <StyledGalleryBreachNotification>
                            <BreachNotificationWrapper
                                publication={gallery}
                                requiredAccess={requiredAccess}
                                breachDeal={deal}
                                breachCreativeName={creativeName}
                                onEvent={onEvent}
                                type={type}
                            />
                        </StyledGalleryBreachNotification>
                    </Fragment>
                )
            }}
        />
    )
}

GalleryBreach.displayName = 'GalleryBreach'
